import { ComponentProps, forwardRef } from "react";
import { createLink, LinkComponent } from "@vixi/router";
import { VariantProps } from "class-variance-authority";
import { ButtonIcon, buttonVariants, CustomButtonProps } from "../base/button";
import { cn } from "@/lib";

type StyledButtonLinkProps = ComponentProps<"a"> &
  VariantProps<typeof buttonVariants> &
  CustomButtonProps;

export const HtmlButtonLink = forwardRef<HTMLAnchorElement, StyledButtonLinkProps>(
  ({ variant, size, color, children, startIcon, endIcon, className, disabled, ...props }, ref) => {
    return (
      <a
        className={cn(buttonVariants({ variant, size, color, disabled }), className)}
        ref={ref}
        {...props}
      >
        {startIcon && <ButtonIcon>{startIcon}</ButtonIcon>}
        {children}
        {endIcon && <ButtonIcon>{endIcon}</ButtonIcon>}
      </a>
    );
  },
);

const CreatedLinkComponent = createLink(HtmlButtonLink);

export const ButtonLink: LinkComponent<typeof HtmlButtonLink> = (props) => {
  return <CreatedLinkComponent preload={"intent"} {...props} />;
};

export type ButtonLinkProps = ComponentProps<typeof ButtonLink>;
